import { Link } from "react-router";
import { Card } from "../components/ui/Card";

export const ForbiddenPage = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-semibold">Access restricted</h1>
      <p className="text-sm text-muted-foreground">
        You do not have permission to view this page.
      </p>
    </div>
    <Card title="Need access?" description="Contact an administrator to request permissions.">
      <Link to="/profile" className="text-sm font-semibold text-primary-text hover:underline">
        Return to Profile
      </Link>
    </Card>
  </div>
);
